import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loading = () => {
  return <CircularProgress />;
};

export default Loading;
